export default "__VITE_ASSET__CzTjaFHh__"